import { render, staticRenderFns } from "./SSignaturePad.vue?vue&type=template&id=e6f85c38&scoped=true"
import script from "./SSignaturePad.vue?vue&type=script&lang=js"
export * from "./SSignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SSignaturePad.vue?vue&type=style&index=0&id=e6f85c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f85c38",
  null
  
)

export default component.exports